import { useUISize } from 'app/utils/web-helpers';
import { View, StyleSheet } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

export function FullWidthContainerView({ children }: { children: React.ReactNode }) {
  const { isSmallUI } = useUISize();
  if (isSmallUI) {
    return children;
  }

  return (
    <SafeAreaView style={styles.safeArea}>
      <View style={styles.container}>{children}</View>
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  safeArea: {
    flex: 1,
    alignItems: 'center',
  },
  container: {
    flex: 1,
    width: '100%',
  },
});
